import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  hasAllPrivilegesSelector,
  privilegesSelector,
} from 'features/user/selectors';

type RequirePrivilegeProps = {
  requiredPrivileges: string[];
  redirectTo?: string;
  fallback?: React.ReactNode;
  throw404?: boolean;
} & React.PropsWithChildren;

export default function RequirePrivilege({
  requiredPrivileges,
  redirectTo,
  fallback,
  throw404,
  children,
}: RequirePrivilegeProps) {
  const privileges = useSelector(privilegesSelector);
  const hasAllRequiredPrivileges = useSelector(
    hasAllPrivilegesSelector(requiredPrivileges)
  );

  if (hasAllRequiredPrivileges) {
    return <>{children}</>;
  }

  if (privileges !== undefined && redirectTo !== undefined) {
    return <Navigate to={redirectTo} replace />;
  }

  if (privileges !== undefined && fallback != undefined) {
    return <>{fallback}</>;
  }

  if (privileges !== undefined && throw404) {
    throw new Response('Not found', { status: 404 });
  }

  return <></>;
}
